import {Component} from 'react';
import axios from "axios"
import Nav from "../../Componet/Nav";
import Swal from "sweetalert2";
import myconfig from "../../myconfig";
import {Modal} from "react-bootstrap";
import * as XLSX from "xlsx";

let source = axios.CancelToken.source();

class Allocate_finance extends Component {
    constructor() {
        super();
        this.state = {
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',
        }
    }

    async componentDidMount() {
        this.get_allocate_finance();
    }

    inputmgt = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
    }
    inputmgt_fitler = (event) => {
        event.preventDefault();
        var name = event.target.name;
        var value = event.target.value;
        this.setState({
            [name]: value,
        })
        if (this.state.vehsorginall) {
            let temp = this.state.vehsorginal.datas;
            if (value != "") {
                temp = temp.filter(v => {
                    if (v.plate_no.toUpperCase().includes(value.toUpperCase())) {
                        return value;
                    }
                })
            }
            this.setState({
                vehs: temp,
            })
        }
    }
    get_allocate_finance = () => {
        this.setState({
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',
        });
        let baseurl = myconfig.get_allocate_finance;
        let redirecttologin = myconfig.redirecttologin;
        this.setState({
            vehs: [],
            vehsorginal: null,
            vehsorginall: false,
            txtsearch: '',

            fright: false,
            frightno: "",
            assignment:null,

            openorder: false,
            openordersorginal: null,
            openordersorginall: false,
            orders: [],
            txtsearch_order: '',
            allocation_id: '',

            assignshow:false,
            wizard:0,
        })
        axios.post(baseurl, {
            sid: window.localStorage.getItem("ntfms_sid"),
            order_id: this.state.order_id,
        }, {cancelToken: source.token}).then(res => {
            if (res.data.auth == false) {
                window.localStorage.setItem("ntfms_sid", null);
                window.localStorage.setItem("ntfms_username", null);
                window.localStorage.setItem("ntfms_name", null);
                var win = window.open(redirecttologin, "_self");
            } else if (res.data.success == false) {
                Swal.fire({
                    title: 'Error!',
                    text: res.data.msg,
                    icon: 'error',
                    confirmButtonText: 'Okay'
                })
            } else {
                this.setState({
                    vehs: res.data.datas,
                    vehsorginal: res.data,
                    vehsorginall: true,
                })
            }
        }).catch((e) => {
            console.log(e.message);
        });
    }
    tabledata = () => {
        let count = 0;
        let retdata = null;
        if (this.state.vehsorginall) {
            retdata = this.state.vehs.map(value => {
                count = count + 1
                if(value.status=="COST_APPROVED") {
                    return (<tr style={{backgroundColor:"green",color:"white"}}>
                        <td>{count}</td>
                        <td>{value.plate_no}</td>
                        <td>{value.dri_name}</td>
                        <td>{value.dri_phoneno}</td>
                        <td>{value.tra_plateno}</td>
                        <td>{value.org}</td>
                        <td>{value.des}</td>
                        <td>{value.cargo_id}</td>
                        <td>{value.customer_id}</td>
                        <td>{value.frightno}</td>
                        <td>{value.actfuelqtyempty}</td>
                        <td>{value.actfuelqtyload}</td>
                        <td>{value.actprediemempty}</td>
                        <td>{value.actpredieload}</td>
                        <td>{value.acthandlefeeempty}</td>
                        <td>{value.acthandlefeeload}</td>
                        <td>{value.status}</td>
                        <td>{value.approved_at}</td>
                    </tr>)
                }
                else
                {
                    return (<tr style={{backgroundColor:"red",color:"white"}}>
                        <td>{count}</td>
                        <td>{value.plate_no}</td>
                        <td>{value.dri_name}</td>
                        <td>{value.dri_phoneno}</td>
                        <td>{value.tra_plateno}</td>
                        <td>{value.org}</td>
                        <td>{value.des}</td>
                        <td>{value.cargo_id}</td>
                        <td>{value.customer_id}</td>
                        <td>{value.frightno}</td>
                        <td>{value.actfuelqtyempty}</td>
                        <td>{value.actfuelqtyload}</td>
                        <td>{value.actprediemempty}</td>
                        <td>{value.actpredieload}</td>
                        <td>{value.acthandlefeeempty}</td>
                        <td>{value.acthandlefeeload}</td>
                        <td>{value.status}</td>
                        <td>{value.approved_at}</td>
                    </tr>)
                }
            })

        }
        return (<>{retdata}</>)
    }

    componentWillUnmount() {
        try {
            if (source) {
                source.cancel("Landing Component got unmounted");
            }
        } catch (e) {

        }
    }
    btnexport = (event) => {
        event.preventDefault();
        let wb=XLSX.utils.book_new();
        wb.SheetNames.push("Allocation");
        let wb2= XLSX.utils.table_to_sheet(document.getElementById('report_2'));
        wb.Sheets["Allocation"]=wb2;
        XLSX.writeFile(wb,"Allocation.xlsx");
    }
    render() {
        return (
            <>
                <Nav type="allocate_finance"/>
                <div className="content-wrapper">
                    <div className="content-header">
                        <div className="container-fluid">
                            <div className="row mb-2">
                                <div className="col-sm-6">
                                    <h1 className="m-0">Finance Report</h1>
                                </div>
                                <div className="col-sm-6">
                                    <ol className="breadcrumb float-sm-right">
                                        <li className="breadcrumb-item"><a href={this.state.urlorder}>Finance</a>
                                        </li>
                                        <li className="breadcrumb-item active"></li>
                                    </ol>
                                </div>
                            </div>
                        </div>
                    </div>
                    <section className="content">
                        <div className="row">
                            <div className="col-12">
                                <div className="card">
                                    <div className="card-header">
                                        <div className="card-tools">
                                            <div className="input-group input-group-sm" style={{width: '150px'}}>
                                                <input type="text" name="txtsearch" onChange={this.inputmgt_fitler}
                                                       className="form-control float-right" placeholder="Search"/>
                                                <div className="input-group-append">
                                                    <button type="submit" className="btn btn-default">
                                                        <i className="fas fa-search"/>
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="card-body table-responsive p-0" style={{height: '500px'}}>
                                        <div className="p-2 text-left"><a href="#" onClick={this.btnexport}>.xlsx</a></div>
                                        <table id="report_2" className="table table-head-fixed text-nowrap">
                                            <thead>
                                            <tr>
                                                <th>#</th>
                                                <th>Truck Plate #</th>
                                                <th>Driver Name</th>
                                                <th>Driver Phone</th>
                                                <th>Trailer #</th>
                                                <th>Org</th>
                                                <th>Des</th>
                                                <th>Cargo</th>
                                                <th>Customer</th>
                                                <th>Fright #</th>
                                                <th>Fuel QTY Empty</th>
                                                <th>Fuel QTY Loaded</th>
                                                <th>Per-Diem Empty</th>
                                                <th>Per-Diem Loaded</th>
                                                <th>Handling Fee Empty</th>
                                                <th>Handling Fee Loaded</th>
                                                <th>Status</th>
                                                <th>Approved at</th>
                                            </tr>
                                            </thead>
                                            <tbody>
                                            {this.tabledata()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {/* /.card-body */}
                                </div>
                                {/* /.card */}
                            </div>
                        </div>
                    </section>
                </div>
            </>
        )
    }
}

export default Allocate_finance;
